import { Component, ViewEncapsulation, ViewChild, Input } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { get, orderBy, compact } from 'lodash';
import { map } from 'rxjs/operators';
import { Validators, FormBuilder } from '@angular/forms';
import { CreateMessageActions, MyPenmateActions } from '../actions';
import { ActivatedRoute } from '@angular/router';
import { PopoverController, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { StripeAddressChangeEvent, StripeAddressComponent } from '../shared/components/stripe-address/stripe-address.component';
import { AppState, LetterService, EventService, mapStates } from '../services';

@Component({
  selector: 'pm-message-incomplete-modal',
  templateUrl: 'message-incomplete-modal.html',
  styleUrls: ['./message-incomplete-modal.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageIncompleteModal {
  @ViewChild('scrollContent', { static: false }) scrollContent;
  @ViewChild('stripeAddress', { static: false }) stripeAddressComponent: StripeAddressComponent;
  penmate;
  navCtrl;
  isPostcard;
  formSubmitted;
  state$;
  STATE_NAMES;
  addressForm;
  currentMessage;
  mailingAddress;
  mailingAddressValid = false;

  constructor(
    private navParams: NavParams,
    private sanitizer: DomSanitizer,
    public route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    private createMessageActions: CreateMessageActions,
    private myPenmateActions: MyPenmateActions,
    private store: Store<AppState>,
  ) {
    this.state$ = this.route.paramMap.pipe(map(() => window.history.state));
    this.currentMessage = this.navParams.get('currentMessage') || {};
    this.STATE_NAMES = mapStates.map((m) => m['abbreviation']);
    const { default_from_address, from_address, inmate } = this.currentMessage;
    const defaultFromAddress = default_from_address || from_address || {};
    const isEmptyAddress = (value) => !value || Object.keys(value).length === 0;
    const hasReturnAddress = !isEmptyAddress(this.currentMessage.returnAddress);
    const hasDefaultReturnAddress = !isEmptyAddress(this.currentMessage.defaultReturnAddress);
    if (!hasDefaultReturnAddress && !isEmptyAddress(defaultFromAddress)) {
      this.currentMessage.defaultReturnAddress = defaultFromAddress;
    }
    if (!hasReturnAddress && !isEmptyAddress(from_address)) {
      this.currentMessage.returnAddress = from_address;
    }
    this.penmate = this.navParams.get('penmate');
    this.navCtrl = this.state$.navCtrl;

    this.addressForm = this.formBuilder.group({
      toAddress: this.formBuilder.group({
        first_name: [null, Validators.required],
        last_name: [null, Validators.required],
        facility: [null, Validators.required],
        id_number: [inmate.inmate_id],
      }),
      fromAddress: this.formBuilder.group({
        name: [null, Validators.required],
        address_line1: [null, Validators.required],
        address_line2: [null],
        address_city: [null, Validators.required],
        address_country: ['US',  Validators.required],
        address_state: [null],
        address_zip: [null, Validators.required],
      }),
    });
    
    this.addressForm.controls.toAddress.patchValue(inmate);
    this.addressForm.controls.fromAddress.patchValue({
      ...defaultFromAddress,
      address_line1: defaultFromAddress.address_line1 || defaultFromAddress.email_address_line1,
    });
  }


  onSaveAndContinue() {
    if (!this.mailingAddressValid || !this.currentMessage.id || !this.addressForm.controls.toAddress.valid) {
      return;
    }
    this.store.dispatch(
      this.createMessageActions.confirmMailingAddress(this.currentMessage.id, {
        confirmed_address:  {
          toAddress: this.addressForm.value.toAddress,
          fromAddress: this.mailingAddress,
        }
      }),
    );
    setTimeout(() => {
    	this.modalCtrl.dismiss();
    }, 500)
  }

  onCancel() {
    this.modalCtrl.dismiss();
  }

  onAddressChanged(changeEvent: StripeAddressChangeEvent) {
    this.mailingAddress = changeEvent.value;
    if (changeEvent.complete) {
      this.mailingAddressValid = true;
    } else {
      this.mailingAddressValid = false;
    }
  }

  onFocusZip = () => {
    if (this.scrollContent) {
      this.scrollContent.scrollToBottom();
    }
  };

}
